export const useQueryDropdown = {
  staleTime: 10 * 60 * 1000, // 10 MINUTES
  cacheTime: 15 * 60 * 1000, // 15 MINUTES
};
